module.exports = __webpack_public_path__ + "img/public/SiteIcons/becomeaHostIcon.svg?09b46a03";